<template>
  <v-layout class="login-page-wrapper" align-center justify-center v-if="branding">
    <v-layout class="login-page" column fill-height>

      <v-layout class="header-inner"
                align-center
                justify-center column
                :style="{ backgroundColor: branding.primary_color}">

        <div @click="goToHomepage" class="regular_link">
          <VcImage class="logo" :image="branding.logo_path"/>
        </div>

        <div  class="header-title"
              :style="{ color: branding.text_color}">
          {{$t('common.login.title')}}
        </div>

        <v-tabs v-if="showTabs"
                :color="branding.primary_color"
                dark
                grow
                value
                slider-size="4"
                background-color='transparent'
                v-model="activeTab"
                :style="{ color: branding.text_color}"
                active-class="active-tab" :slider-color="branding.secondary_color">

            <v-tab :style="{ color: branding.text_color}" :ripple="false" :key="'password'">{{$t('common.login.using_my_password')}}</v-tab>
            <v-tab :style="{ color: branding.text_color}" :ripple="false" :key="'code'">{{$t('common.login.using_code')}}</v-tab>
        </v-tabs>
      </v-layout>

      <div class="v-tabs-wrapper">
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-if="showLoginWithPass" fill-height :key="'password'">
            <LoginWithPassword/>
          </v-tab-item>

          <v-tab-item v-if="showLoginWithCode" fill-height :key="'code'">
            <LoginWithCode/>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div  class="sign-up"
            v-if="!mobileApp && !branding.hide_sign_up">

        {{$t('common.login.dont_have_an_account')}}

        <span @click="signUp">
          {{$t('common.login.sign_up_2')}}
        </span>
      </div>
    </v-layout>
  </v-layout>

</template>

<script>

import LoginWithPassword from "../components/LoginWithPassword";
import LoginWithCode from "../components/LoginWithCode";
import {mapGetters} from "vuex";
import {postMessageService} from "@/modules/common/services";

  export default {
    name: 'Login',
    components: {LoginWithCode, LoginWithPassword},

    data: function () {
      return {
        activeTab: 0,
      }
    },
    methods:{
      goToHomepage: function() {
        postMessageService.post('go_to_homepage')
      },
      signUp: function() {
        postMessageService.post('signup')
      },
      addRecaptcha: function () {
        let recaptchaScript = "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
        let scriptElement = document.createElement('script')
        scriptElement.src = recaptchaScript
        scriptElement.async = true
        scriptElement.defer = true
        document.head.appendChild(scriptElement)
      },
      runTealiumScript: function () {
        const tealium_script = this.branding.tealium_script
        if (tealium_script) {
          let script = this.mobile ? tealium_script.mobile : tealium_script.other
          if (script) {
            let tealium_script = document.createElement('script')
            tealium_script.innerHTML = script
            document.body.appendChild(tealium_script)

            document.addEventListener('utag_loaded', function(e) {
              utag.view({
                "login_state"  : "0",
                "page_name"    : "app_login_page"
              })
            })
          }
        }
      },
      trackVcita: function() {
        if (this.$store.getters.vcitaWindowLocation) {
          this.$track('Login Form', {'Info': 'Popup','Platform': this.$store.getters.platform, 'Page': 'App Login', 'Origin': 'Login Form'})
        }
      }
    },
    computed:{
      ...mapGetters("brandModule", ["branding"]),
      mobileApp(){
        return this.$store.getters.isMobileApp
      },
      mobile(){
        return this.$store.getters.isMobile
      },
      showTabs() {
        return this.showLoginWithPass && this.showLoginWithCode
      },
      showLoginWithPass() {
        return !this.branding.user_identity_manager_enable || !this.branding.use_login_with_code
      },
      showLoginWithCode() {
        return this.branding.use_login_with_code || this.branding.user_identity_manager_enable
      }
    },
    mounted() {
      this.addRecaptcha()
      this.runTealiumScript()
      this.trackVcita()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this components only -->
<style lang="scss">
  @import "../../../assets/scss/abstract/_variables.scss";
  @import "../../../assets/scss/abstract/_i18n-mixins.scss";
  @import "../../../assets/scss/abstract/_mixins.scss";

  .regular_link {
    display:flex;
  }

  section {
    height: 100%;
  }

  .login-wrapper {
    max-width: 100%;
    width:100%;
    padding: 16px 10px;

    form {
      width: 100%;
    }
  }

  .sign-up {
    font-family: var(--font3);
    color: rgba(51, 51, 51, 0.54);
    font-size: 14px;
    text-align: center;
    height: 43px;
    text-decoration: none;
    background-color:#ffffff;

    span {
      color: $linkColor;
      @include i-margin-mirror(5px, 0);
      cursor: pointer;
    }
  }

  .login-page-wrapper {
    height: 100%;

    .login-page {
      background-color: $appBackgroundColor;
      width:100%;

      .v-tabs-wrapper {
        flex: 1;
        display: -ms-flex;
      }

      .v-tabs__slider {
        height: 5px;
      }

      .v-tabs__div {
        text-transform: none;
        font-family: var(--font2);
        padding: 0px 10px;
      }


      .active-tab {
        opacity: 1;
      }

      .v-tab{
        text-transform: capitalize;
        font-weight: 400;
      }

      .theme--dark.v-tabs .v-tab--active:hover::before, .theme--dark.v-tabs .v-tab--active::before {
        opacity: 0;
      }

      .theme--dark.v-tabs .v-tab:hover::before {
        opacity: 0;
      }

      .v-window {
        height: 100%;
        background: #ffffff;

        .v-window__container {
          height: 100%;
          width: 335px;
          margin: 0 auto;

          .v-window-item {
            height: 100%;

            .v-card {
              height: 100%
            }
          }
        }
      }
    }
  }

  .header-inner {
    width: 100%;
    flex: 0 0 170px;
    color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    z-index: 99;

    .logo {
      height: 41px !important;
      margin-top: 18px;
      cursor:pointer;
    }

    .header-title {
      font-family: var(--font2);
      font-size: 22px;
      margin-top: 17px;
    }

    .v-tabs {
      margin-top: 14px;
      width: 100%;
    }
  }

  .v-btn {
    width: 100%;
    margin: 0;
    font-size: 15px;
    height: 44px;
  }

  .forgot-password {
    color: $linkColor;
    font-size: 12px;
    margin-top: -14px;
    cursor: pointer;
    z-index: 99;
    position: relative;
    margin-bottom: 26px;
    @include i-text-align(right);
    text-decoration: none;
    display: block;
  }

  .back-button {
    color: $linkColor;
    font-size: 12px;
    cursor: pointer;
    z-index: 99;
    @include i-text-align(center);
    display: block;
  }

  @include md-and-up {

    .header-inner {

      .v-tabs {
        width: auto;
      }
    }

    .login-page-wrapper {

      .login-wrapper {
        padding: 0px;

        form {
          margin-top: 18px;
        }
      }

      .login-page {
        padding: 0px;
        border-radius: 5px;
        box-shadow: $boxShadow;
        max-height: 650px;
        max-width: 900px;

        .v-tabs-wrapper {
          width: 100%;
          background-color: #ffffff;
        }
      }
    }
  }

</style>
